import { getImageDimensions } from '@/lib/images';

import type { Image, Media, MediaLarge } from './ImagesGallery';

export const getMediaDimensions = async (
  media: Media[],
  mediaLarge: MediaLarge[],
): Promise<Image[]> => {
  const imagesAll = media.map((item, i) => ({
    thumb: item,
    large: mediaLarge[i],
  }));

  return await Promise.all(
    imagesAll.map(async (item) => {
      const dimensions = await getImageDimensions(item.large.url);
      return {
        thumb: item.thumb,
        large: { ...item.large, ...dimensions },
      };
    }),
  );
};
